/**
 * Created by mbyron on 10/19/17.
 */
import { View } from "extensions/marionette";
import $ from "jquery";
import Radio from "backbone.radio";

import { nextTick } from "common/utils";

import { Dropdown } from "common/components/dropdown/dropdown";

import tokenMenuTemplate from "./tokenDropMenu.jst";

export const TokenDropMenu = View.extend({
    className() {
        const data = this.getOption("data");
        const operator = data.operator === "=" ? "included" : "excluded";
        return `token-menu-drop ${operator}`;
    },
    
    template: tokenMenuTemplate,
    
    regions: {
        ddRegion: ".dd"
    },
    
    onRender() {
        nextTick(() => {
            this.renderDropDown();
            nextTick(this.docBindHideTokenMenu.bind(this));
        });
    },
    
    events: {
        "click .left, .right": "changeOperator"
    },
    
    changeOperator() {
        this.triggerMethod("change:operator");
    },
    
    renderDropDown() {
        const { ref } = this.getOption("data");
        const filter = new Dropdown({
            showFilterInput: true,
            collection: this.getOption("labels").map((item) => ({
                selected: item.value === ref,
                ...item
            })),
            onChangeValue: (newValue) => {
                this.triggerMethod("change:value", newValue);
            }
        });
        this.showChildView("ddRegion", filter);
        
        // This tokenDropMenu view has Dropdown component as it's region.
        // We should programmatically toggle it to show up
        filter.toggle();
        
        // Kill the filter before destroy
        this.on("before:destroy", () => {
            filter.destroy();
        });
        
        // Kill it onHide
        this.listenTo(filter, "hidden", () => {
            // Have to do this cause of hide event if user happens to click inside the tokenMenu
            this.off("before:destroy"); // Turn off destroy
            this.renderDropDown();
        });
    },
    
    docBindHideTokenMenu() {
        $(document).off(`click.${this.cid}`).on(`click.${this.cid}`, (e) => {
            if ($(e.target).closest(".token-menu-drop").length === 0 && !this.isDestroyed()) {
                this.destroy();
            }
        });
    },
    
    onDestroy() {
        $(document).off(`click.${this.cid}`);
    },
    
    templateContext() {
        return {
            typeAlias: Radio.channel("main").request("get:getters").findPivotName(this.getOption("data").category)
        };
    }
});
